module.exports = __webpack_public_path__ + "static/img/category-analysis1.d576cea4.svg";